import { Controller } from '@hotwired/stimulus'

// Shows the "past N days" or the "between" inputs of a date-range form
// depending on the selected mode.
export default class extends Controller {
  static targets = ['mode', 'past', 'between']

  connect() {
    this.toggle()
  }

  toggle() {
    const between = this.modeTarget.value === 'between'
    this.pastTargets.forEach(el => el.classList.toggle('d-none', between))
    this.betweenTargets.forEach(el => el.classList.toggle('d-none', !between))
  }
}
